import { useDispatch, useSelector } from 'react-redux'
import { getCashPaymentAlreadyAppliedModal } from '../../Selectors'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import { useCallback } from 'react'
import { setCashPaymentAlreadyAppliedModal } from '../../ActionCreators'

export const VNCashPaymentAlreadyAppliedModal = () => {
  const dispatch = useDispatch()

  const { open } = useSelector((state) => getCashPaymentAlreadyAppliedModal(state))

  const closeHandler = useCallback(() => {
    dispatch(setCashPaymentAlreadyAppliedModal({ open: false }))
  }, [dispatch])

  if (!open) {
    return null
  }

  return (
    <ConfirmModalV2
      headerText={''}
      subtext={'Only one Cash tender can be applied per order.'}
      singleButtonOnly
      buttonTwoText={'OK'}
      onButtonTwoClick={closeHandler}
    />
  )
}
